<template>
  <select ref="select" @input="bubbleChange">
    <option v-for="ville in villes" :key="ville.id" :value="ville.id">
      {{ ville.name }}
    </option>
    <option :value="null" v-if="villes.length == 0">
      Code postal non reconnu
    </option>
  </select>
</template>

<script>
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import Vue from "vue";

export default {
  name: "Ville",
  props: ["zip"],
  data() {
    return {
      villes: [],
      selectedVille: null
    };
  },

  watch: {
    zip: async function() {
      this.villes = await idyuJsonRpc("getCities", this.$store.state.profile.city.country.id, this.zip);
      await Vue.nextTick();
      this.bubbleChange();
    }
  },

  methods: {
    bubbleChange: function() {
      let res = this.$refs.select.value;
      this.$emit("input", res);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

select {
  max-width: 300px;
}
</style>
